import ClipPathComponent from "./Frame2";
import { useNavigate } from "react-router-dom";
import Btn from "../globalComponents/Btn";
interface HeroSectionProps {
  redirectUrl: string;
}

const HeroSection = ({ redirectUrl }: HeroSectionProps) => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-full md:min-h-0  md:h-[83vh] flex p-8 md:p-0 md:px-[5vw] md:py-[2vw] relative z-10">
      <div className="w-full h-full rounded-2xl overflow-hidden flex flex-col md:flex-row bg-gradient-to-r from-black via-[#134851] to-[#2b9fb4] px-[5vw]">
        <div className="md:w-[50%] w-full h-full flex flex-col p-4 md:p-0 justify-center gap-[2vw]">
          <h1 className="text-2xl md:text-[4vw] font-bold md:leading-[4vw]">
            Delivering Quality Digital Dental Designs!
          </h1>
          <p className="text-md md:text-[1.5vw] font-medium md:leading-[2vw]">
            Digital dental design firm that works as an extension of your team
          </p>
          <div className="flex flex-col md:flex-row md:gap-[2vw] gap-4 items-center text-blue-900 text-sm md:text-[1.5vw] font-normal">
            <button
              onClick={() => navigate("/services")}
              className="bg-[#2b9fb4] hover:bg-[#2b9fb4]/80 h-8 text-md w-32 md:w-[12vw] md:h-[4vw] rounded-full md:text-[1.25vw] "
            >
              Learn More
            </button>
            <Btn
              BtnText="Get Started Today"
              BtnText2="Redirecting..."
              redirectTo={redirectUrl}
            />
          </div>
        </div>
        <div className="md:w-[50%] w-full h-full text-white overflow-hidden">
          <ClipPathComponent />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
